import React from "react";
import styled from "styled-components";

const BaseIcon = styled.svg`
  fill: ${(props) => props.fill || "black"};
  height: ${(props) => props.height || "auto"};
  margin-right: ${(props) => props.mr || "8px"};
  width: ${(props) => props.width || "16px"};
`;

export const AddFileIcon = ({
  fill = "black",
  height = "auto",
  mr = "8px",
  width = "16px",
}) => {
  return (
    <BaseIcon
      fill={fill}
      height={height}
      mr={mr}
      width={width}
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 487.85 599.52"
    >
      <g>
        <path d="M301.57,13.31c-7.36,0-13.31,5.95-13.31,13.31v159.67c0,7.36,5.95,13.31,13.31,13.31h159.67c7.36,0,13.31-5.95,13.31-13.31s-5.95-13.31-13.31-13.31h-146.37V26.61c0-7.36-5.95-13.31-13.31-13.31Z" />
        <path d="M301.57,0H26.61C11.9,0,0,11.9,0,26.61v546.3c0,14.71,11.9,26.61,26.61,26.61h434.62c14.71,0,26.61-11.9,26.61-26.61V186.28c0-7.07-2.81-13.82-7.8-18.81L320.38,7.8c-4.99-4.99-11.75-7.8-18.81-7.8ZM53.22,53.22h237.32l144.08,144.08v348.99H53.22V53.22Z" />
      </g>
      <path d="M328.75,336.7h-169.65c-14.71,0-26.61,11.9-26.61,26.61s11.9,26.61,26.61,26.61h169.65c14.71,0,26.61-11.9,26.61-26.61s-11.9-26.61-26.61-26.61Z" />
      <path d="M243.92,251.88c-14.71,0-26.61,11.9-26.61,26.61v169.65c0,14.71,11.9,26.61,26.61,26.61s26.61-11.9,26.61-26.61v-169.65c0-14.71-11.9-26.61-26.61-26.61Z" />
    </BaseIcon>
  );
};

export const CheckmarkIcon = ({
  fill = "black",
  height = "auto",
  mr = "8px",
  width = "16px",
}) => {
  return (
    <BaseIcon
      fill={fill}
      height={height}
      mr={mr}
      width={width}
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 327.04 278.86"
    >
      <path d="M107.18,278.86c-3.8,0-7.5-1.6-10.2-4.4L3.88,176.66c-5.4-5.6-5.1-14.5.5-19.9,5.6-5.3,14.5-5.2,19.9.5l82.2,86.3L302.08,5.16c4.9-6,13.8-6.9,19.8-2s6.9,13.8,2,19.8l-205.7,250.8c-2.6,3.1-6.3,5-10.4,5.1h-.6Z" />
    </BaseIcon>
  );
};

export const CloseIcon = ({
  fill = "black",
  height = "auto",
  mr = "8px",
  width = "16px",
}) => {
  return (
    <BaseIcon
      fill={fill}
      height={height}
      mr={mr}
      width={width}
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 316.85 317"
    >
      <path d="M18.08,317c-4.61,0-9.22-1.8-12.82-5.41-7.01-7.01-7.01-18.63,0-25.64L285.95,5.26c7.01-7.01,18.63-7.01,25.64,0,7.01,7.01,7.01,18.63,0,25.64L30.9,311.59c-3.61,3.61-8.21,5.41-12.82,5.41h0Z"/>
      <path d="M298.77,317c-4.61,0-9.22-1.8-12.82-5.41L5.26,30.9C-1.75,23.89-1.75,12.27,5.26,5.26c7.01-7.01,18.63-7.01,25.64,0l280.69,280.69c7.01,7.01,7.01,18.63,0,25.64-3.61,3.61-8.21,5.41-12.82,5.41h0Z"/>
    </BaseIcon>
  );
};

export const CopyFileIcon = ({
  fill = "black",
  height = "auto",
  mr = "8px",
  width = "16px",
}) => {
  return (
    <BaseIcon
      fill={fill}
      height={height}
      mr={mr}
      width={width}
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 602 602"
    >
      <path
        d="M499.93,21C486.52,7.51,468.27-.05,449.26,0h-148.26c-39.56.05-71.62,32.11-71.67,71.67v344c.05,39.56,32.11,71.62,71.67,71.67h229.33c39.56-.04,71.62-32.1,71.67-71.67V152.75c.06-19.02-7.5-37.28-21-50.68l-81.07-81.07ZM458.66,29.82c7.94,1.77,15.21,5.73,21,11.45l81.07,81.07c5.75,5.76,9.73,13.05,11.48,21h-70.55c-23.74-.03-42.97-19.26-43-43V29.82h0ZM573.33,415.67c-.03,23.74-19.26,42.97-43,43h-229.33c-23.74-.03-42.97-19.26-43-43V71.67c.03-23.74,19.26-42.97,43-43h129v71.67c.04,39.56,32.1,71.62,71.67,71.67h71.67v243.67h0ZM0,530.33V186.33c.05-39.56,32.11-71.62,71.67-71.67h114.67v28.67h-114.67c-23.74.03-42.97,19.26-43,43v344c.03,23.74,19.26,42.97,43,43h229.33c23.74-.03,42.97-19.26,43-43h28.67c-.04,39.56-32.1,71.62-71.67,71.67H71.67c-39.56-.05-71.62-32.11-71.67-71.67Z"
      />
    </BaseIcon>
  );
};

export const DeleteIcon = ({
  fill = "black",
  height = "auto",
  mr = "8px",
  width = "16px",
}) => {
  return (
    <BaseIcon
      fill={fill}
      height={height}
      mr={mr}
      width={width}
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 637.72 671.99"
    >
      <path d="M609.68,131.67H28.03c-15.49,0-28.03-12.54-28.03-28.03s12.54-28.03,28.03-28.03h581.65c15.49,0,28.03,12.54,28.03,28.03s-12.54,28.03-28.03,28.03Z" />
      <path d="M391.07,115c-6.9-34.13-37.28-58.94-72.21-58.94s-65.37,24.8-72.27,58.94l-54.97-11.11C203.83,43.69,257.32,0,318.86,0s114.97,43.69,127.18,103.89l-54.97,11.11Z" />
      <path d="M507.96,671.99H129.81c-29.37,0-53.85-23.9-55.68-54.37l-29.02-485.9c-.93-15.44,10.87-28.72,26.33-29.62,15.52-.74,28.72,10.9,29.62,26.33l29.02,485.82,377.77,1.67,28.8-487.51c.91-15.47,14.54-26.94,29.65-26.31,15.47.93,27.24,14.21,26.31,29.65l-29.02,485.82c-1.95,30.6-26.36,54.42-55.63,54.42Z" />
      <g>
        <path d="M212.51,569.11c-14.76,0-27.13-11.55-27.95-26.47l-18.67-334.05c-.88-15.46,10.95-28.69,26.41-29.54,15.08-.66,28.69,10.95,29.54,26.42l18.67,334.05c.87,15.46-10.95,28.69-26.42,29.54-.52.03-1.07.05-1.59.05Z" />
        <path d="M425.15,569.11c-.52,0-1.07-.03-1.59-.05-15.46-.85-27.29-14.07-26.41-29.54l18.67-334.05c.85-15.47,14.15-27.16,29.54-26.42,15.46.85,27.29,14.07,26.42,29.54l-18.67,334.05c-.82,14.92-13.19,26.47-27.95,26.47Z" />
      </g>
      <path d="M318.86,569.11c-15.49,0-28.03-12.54-28.03-28.03V207.03c0-15.49,12.54-28.03,28.03-28.03s28.03,12.54,28.03,28.03v334.05c0,15.5-12.54,28.03-28.03,28.03Z" />
    </BaseIcon>
  );
};

export const DownCaretIcon = ({
  fill = "black",
  height = "auto",
  mr = "8px",
  width = "16px",
}) => {
  return (
    <BaseIcon
      fill={fill}
      height={height}
      mr={mr}
      width={width}
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 564.6 425"
    >
      <g id="Layer_1-2" data-name="Layer 1">
        <g id="Triangle_1" data-name="Triangle 1">
          <g id="Triangle_1-2" data-name="Triangle 1-2">
            <polygon points="282.3 425 564.6 0 0 0 282.3 425" />
          </g>
        </g>
      </g>
    </BaseIcon>
  );
};

export const EditIcon = ({
  fill = "black",
  height = "auto",
  mr = "8px",
  width = "16px",
}) => {
  return (
    <BaseIcon
      fill={fill}
      height={height}
      mr={mr}
      width={width}
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 637.72 637.72"
    >
      <g>
        <path d="M132.42,526.51c-7.08,0-13.9-2.8-18.92-7.84-5.41-5.41-8.23-12.85-7.79-20.48l6.95-117.69c.39-6.56,3.16-12.73,7.79-17.35L471.17,12.36c5.02-5.02,11.81-7.84,18.92-7.84h0c7.11,0,13.9,2.82,18.92,7.84l110.74,110.74c5.02,5.02,7.84,11.81,7.84,18.92s-2.82,13.9-7.84,18.92l-350.76,350.82c-4.62,4.62-10.79,7.39-17.35,7.79l-117.64,6.92c-.52.02-1.05.05-1.57.05ZM165.48,393.8l-4.57,77.47,77.42-4.55,324.66-324.71-72.9-72.87L165.48,393.8Z" />
        <path d="M538.37,206.71c-3.42,0-6.85-1.31-9.46-3.92l-99.55-99.55c-5.23-5.23-5.23-13.69,0-18.92,5.23-5.23,13.69-5.23,18.92,0l99.55,99.56c5.23,5.23,5.23,13.69,0,18.92-2.61,2.61-6.04,3.92-9.46,3.92Z" />
        <path d="M150.85,417.31c-2.22,0-4.5.1-6.82.31-2.25.24-4.18.94-6.27,1.25l-4.81,81.47,78.18-4.76c.68-2.92,1.41-5.93,1.83-9.04,3.5-39.59-23.73-69.24-62.11-69.24h0Z" />
      </g>
      <path d="M610.96,637.72H26.76c-14.79,0-26.76-11.97-26.76-26.76V26.76C0,11.97,11.97,0,26.76,0h289.88c14.79,0,26.76,11.97,26.76,26.76s-11.97,26.76-26.76,26.76H53.51v530.69h530.69v-263.18c0-14.79,11.97-26.76,26.76-26.76s26.76,11.97,26.76,26.76v289.93c0,14.79-11.97,26.76-26.76,26.76Z" />
    </BaseIcon>
  );
};

export const FilterIcon = ({
  fill = "black",
  height = "auto",
  mr = "8px",
  width = "16px",
}) => {
  return (
    <BaseIcon
      fill={fill}
      height={height}
      mr={mr}
      width={width}
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 327.7 299.2"
    >
      <g>
        <path d="M146.3,253.9c0,7.7-6.2,13.9-13.9,13.9H13.9c-7.7,0-13.9-6.2-13.9-13.9s6.2-13.9,13.9-13.9h118.5c7.7,0,13.9,6.2,13.9,13.9Z" />
        <path d="M327.7,253.9c0,7.7-6.2,13.9-13.9,13.9h-102.3c-7.7,0-13.9-6.2-13.9-13.9s6.2-13.9,13.9-13.9h102.3c7.7,0,13.9,6.2,13.9,13.9Z" />
        <path d="M220.7,253.9c0,25-20.3,45.3-45.3,45.3s-45.3-20.3-45.3-45.3,20.3-45.3,45.3-45.3,45.3,20.3,45.3,45.3ZM157.9,253.9c0,9.6,7.8,17.4,17.4,17.4s17.4-7.8,17.4-17.4-7.8-17.4-17.4-17.4-17.4,7.8-17.4,17.4Z" />
      </g>
      <g>
        <path d="M211.4,149.6c0,7.7-6.2,13.9-13.9,13.9H13.9c-7.7,0-13.9-6.2-13.9-13.9s6.2-13.9,13.9-13.9h183.5c7.7,0,13.9,6.2,13.9,13.9h.1Z" />
        <path d="M327.7,149.6c0,7.7-6.2,13.9-13.9,13.9h-46.6c-7.7,0-13.9-6.2-13.9-13.9s6.2-13.9,13.9-13.9h46.6c7.7,0,13.9,6.2,13.9,13.9Z" />
        <path d="M276.4,149.6c0,25-20.3,45.3-45.3,45.3s-45.3-20.3-45.3-45.3,20.3-45.3,45.3-45.3,45.3,20.3,45.3,45.3ZM213.7,149.6c0,9.6,7.8,17.4,17.4,17.4s17.4-7.8,17.4-17.4-7.8-17.4-17.4-17.4-17.4,7.8-17.4,17.4Z" />
      </g>
      <g>
        <path d="M78.9,45.3c0,7.7-6.2,13.9-13.9,13.9H13.9c-7.7,0-13.9-6.2-13.9-13.9s6.2-13.9,13.9-13.9h51.1c7.7,0,13.9,6.2,13.9,13.9Z" />
        <path d="M327.7,45.3c0,7.7-6.2,13.9-13.9,13.9h-181.3c-7.7,0-13.9-6.2-13.9-13.9s6.2-13.9,13.9-13.9h181.3c7.7,0,13.9,6.2,13.9,13.9Z" />
        <path d="M141.7,45.3c0,25-20.3,45.3-45.3,45.3s-45.3-20.3-45.3-45.3S71.4,0,96.4,0s45.3,20.3,45.3,45.3ZM78.9,45.3c0,9.6,7.8,17.4,17.4,17.4s17.4-7.8,17.4-17.4-7.8-17.4-17.4-17.4-17.4,7.8-17.4,17.4Z" />
      </g>
    </BaseIcon>
  );
};

export const GlobeViewIcon = ({
  fill = "black",
  height = "auto",
  mr = "8px",
  width = "16px",
}) => {
  return (
    <BaseIcon
      fill={fill}
      height={height}
      mr={mr}
      width={width}
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 448.85 448.84"
    >
      <path d="M448.85,224.42c0,123.43-100.99,224.42-224.42,224.42S0,347.86,0,224.42,100.99,0,224.42,0s224.42,100.99,224.42,224.42" />
      <path
        d="M242.38,419.67l-15.71-1.12v-11.22l4.49-7.85-1.12-10.1,5.61-8.98,3.37-21.32c1.12-7.85-2.24-15.71-8.98-20.2h0c-3.37-2.24-5.61-5.61-7.85-8.98l-6.73-15.71-6.73-4.49v-5.61l2.24-6.73,1.12-6.73,8.98-7.85-13.47-12.34-2.24-2.24-10.1-7.85s-1.12,0-1.12-1.12l-16.83-11.22c-1.12-1.12-2.24-1.12-4.49-2.24l-10.1-3.37c-1.12,0-2.24-1.12-3.37-1.12l-17.95-10.1c-2.24-1.12-4.49-3.37-5.61-5.61l-11.22-14.59c-1.12-2.24-2.24-3.37-3.37-5.61l-7.85-22.44c-1.12-2.24-2.24-4.49-3.37-5.61l-1.12-2.24c-2.24-3.37-4.49-7.85-4.49-12.34v-5.61c0-2.24,0-4.49,1.12-6.73l7.85-20.2c1.12-3.37,1.12-6.73,1.12-10.1l-5.61-37.03-8.98-2.24-12.34,7.85-2.24-7.85,24.69-17.95v-5.61l13.47-5.61c4.49-2.24,8.98-2.24,13.47-1.12l43.76,11.22,8.98,1.12,14.59-1.12,1.12,7.85-21.32,23.56,3.37,8.98,6.73-1.12,15.71,8.98,7.85-3.37,2.24-23.56h8.98l14.59,6.73c3.37,1.12,6.73,4.49,8.98,7.85l2.24,3.37c1.12,1.12,2.24,3.37,4.49,4.49l8.98,7.85c2.24,2.24,3.37,3.37,5.61,5.61l8.98,16.83-4.49,4.49-14.59,4.49-8.98,1.12-15.71,11.22-1.12,1.12-4.49,3.37c-3.37,2.24-5.61,5.61-6.73,8.98l-1.12,2.24c-1.12,3.37-3.37,6.73-5.61,8.98l-13.47,12.34-5.61,3.37-38.15,6.73-1.12,3.37c-1.12,5.61,0,12.34,4.49,16.83l6.73,7.85c2.24,2.24,5.61,4.49,8.98,5.61l11.22,4.49c2.24,1.12,4.49,2.24,6.73,4.49l22.44,21.32,4.49-5.61,5.61-3.37c4.49-2.24,8.98-3.37,13.47-2.24l17.95,3.37,6.73,4.49,19.08,10.1,37.03,21.32c1.12,0,2.24,1.12,2.24,2.24l7.85,6.73v7.85l-10.1,11.22c-1.12,1.12-2.24,3.37-3.37,4.49l-7.85,16.83c-1.12,2.24-3.37,5.61-5.61,6.73l-16.83,13.47-1.12,1.12-19.08,16.83-6.73,5.61-7.85,4.49-4.49,2.24-6.73,5.61-3.37,6.73-1.12,11.22-.02-.02ZM224.42,33.66l6.73,6.73,29.18,25.81,4.49,8.98,12.34,12.34,6.73,3.37,3.37-3.37v-20.2l5.61-7.85,2.24-5.61-20.2-16.83c-2.24-2.24-4.49-3.37-7.85-4.49l-7.85-4.49c-4.49-2.24-7.85-3.37-12.34-3.37h0c-5.61,0-10.1,0-15.71,2.24l-4.49,1.12-2.24,5.61h0ZM324.29,48.25l32.54,61.72,23.56,21.32v6.73l-5.61,2.24,5.61,20.2h7.85l3.37-5.61-2.24-19.08,7.85-3.37,10.1,20.2,8.98-5.61c-1.12,1.12-42.64-87.53-92.01-98.75h0ZM394.98,334.39s23.56-52.74,22.44-79.67l-5.61-4.49-6.73,7.85-8.98,4.49-14.59-20.2v-47.13l6.73-8.98-3.37-8.98,7.85-8.98,14.59-5.61,8.98,11.22,2.24-7.85,4.49,1.12c8.98,30.3,10.1,61.72,5.61,92.01-4.49,26.93-13.47,51.62-26.93,75.18h-6.73v.02Z"
        style="fill: #fff;"
      />
    </BaseIcon>
  );
};

export const GridViewIcon = ({
  fill = "black",
  height = "auto",
  mr = "8px",
  width = "16px",
}) => {
  return (
    <BaseIcon
      fill={fill}
      height={height}
      mr={mr}
      width={width}
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 408.67 408.67"
    >
      <rect width="126.67" height="126.67" rx="10" ry="10" />
      <rect y="141" width="126.67" height="126.67" rx="10" ry="10" />
      <rect y="282" width="126.67" height="126.67" rx="10" ry="10" />
      <rect x="282" width="126.67" height="126.67" rx="10" ry="10" />
      <rect x="282" y="141" width="126.67" height="126.67" rx="10" ry="10" />
      <rect x="282" y="282" width="126.67" height="126.67" rx="10" ry="10" />
      <rect x="141" width="126.67" height="126.67" rx="10" ry="10" />
      <rect x="141" y="141" width="126.67" height="126.67" rx="10" ry="10" />
      <rect x="141" y="282" width="126.67" height="126.67" rx="10" ry="10" />
    </BaseIcon>
  );
};

export const HideIcon = ({
  fill = "black",
  height = "auto",
  mr = "8px",
  width = "16px",
}) => {
  return (
    <BaseIcon
      fill={fill}
      height={height}
      mr={mr}
      width={width}
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 632.99 460.43"
    >
      <path d="M316.49,460.43c-145.23,0-271.88-89.1-315.12-221.68-1.83-5.56-1.83-11.52,0-17.07C44.64,89.1,171.29,0,316.49,0s271.85,89.1,315.13,221.68c1.83,5.56,1.83,11.51,0,17.07-43.25,132.58-169.9,221.68-315.13,221.68ZM56.56,230.22c38.44,105.2,141.74,175.24,259.93,175.24s221.49-70.04,259.94-175.24c-38.47-105.2-141.74-175.24-259.94-175.24S95.03,125.02,56.56,230.22Z" />
      <g>
        <path d="M316.49,379.12c-82.12,0-148.93-66.82-148.93-148.93,0-15.19,12.29-27.49,27.49-27.49s27.49,12.3,27.49,27.49c0,51.81,42.15,93.96,93.95,93.96,15.2,0,27.49,12.3,27.49,27.49s-12.29,27.49-27.49,27.49Z" />
        <path d="M437.89,257.68c-15.2,0-27.49-12.29-27.49-27.49,0-51.78-42.12-93.9-93.9-93.9-15.19,0-27.49-12.29-27.49-27.49s12.3-27.49,27.49-27.49c82.09,0,148.88,66.79,148.88,148.88,0,15.2-12.3,27.49-27.49,27.49Z" />
      </g>
      <path d="M512.46,453.7c-7.03,0-14.07-2.69-19.43-8.05L101.04,53.64c-10.74-10.74-10.74-28.13,0-38.87,10.74-10.74,28.13-10.74,38.87,0l391.98,392.01c10.74,10.74,10.74,28.13,0,38.87-5.37,5.37-12.4,8.05-19.44,8.05Z" />
    </BaseIcon>
  );
};

export const InfoIcon = ({
  fill = "black",
  height = "auto",
  mr = "8px",
  width = "16px",
}) => {
  return (
    <BaseIcon
      fill={fill}
      height={height}
      mr={mr}
      width={width}
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 581.28 649.23"
    >
      <path d="M290.59,581.53c-77.66,0-150.67-30.24-205.58-85.14-113.37-113.4-113.35-297.88.05-411.26C139.97,30.24,212.98,0,290.64,0s150.7,30.24,205.63,85.14c113.35,113.4,113.35,297.86,0,411.21-54.95,54.93-127.99,85.19-205.68,85.19ZM290.64,49.38c-64.48,0-125.09,25.1-170.66,70.67-94.13,94.13-94.16,247.29-.05,341.42,45.57,45.57,106.19,70.67,170.66,70.67s125.14-25.13,170.76-70.72c94.09-94.11,94.09-247.24,0-341.38-45.59-45.57-106.21-70.67-170.71-70.67Z" />
      <text
        transform="translate(186.86 483.78)"
        style="font-family: Georgia-Bold, Georgia; font-size: 545.62px; font-weight: 700;"
      >
        <tspan x="0" y="0">
          !
        </tspan>
      </text>
    </BaseIcon>
  );
};

export const LeftCaretIcon = ({
  fill = "black",
  height = "auto",
  mr = "8px",
  width = "16px",
}) => {
  return (
    <BaseIcon
      fill={fill}
      height={height}
      mr={mr}
      width={width}
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 425 564.6"
    >
      <g id="Layer_1-2" data-name="Layer 1">
        <g id="Layer_1-2" data-name="Layer 1-2">
          <g id="Triangle_1" data-name="Triangle 1">
            <g id="Triangle_1-2" data-name="Triangle 1-2">
              <polygon points="0 282.3 425 564.6 425 0 0 282.3" />
            </g>
          </g>
        </g>
      </g>
    </BaseIcon>
  );
};

export const ListViewIcon = ({
  fill = "black",
  height = "auto",
  mr = "8px",
  width = "16px",
}) => {
  return (
    <BaseIcon
      fill={fill}
      height={height}
      mr={mr}
      width={width}
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 408.67 408.67"
    >
      <rect width="408.67" height="80.01" rx="10" ry="10" />
      <rect y="328.66" width="408.67" height="80.01" rx="10" ry="10" />
      <rect y="219.11" width="408.67" height="80.01" rx="10" ry="10" />
      <rect y="109.55" width="408.67" height="80.01" rx="10" ry="10" />
    </BaseIcon>
  );
};

export const LockIcon = ({
  fill = "black",
  height = "auto",
  mr = "8px",
  width = "16px",
}) => {
  return (
    <BaseIcon
      fill={fill}
      height={height}
      mr={mr}
      width={width}
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 587.07 642.63"
    >
      <path d="M533.7,642.63H53.37c-29.43,0-53.37-23.95-53.37-53.37v-284.62c0-29.42,23.94-53.37,53.37-53.37h480.33c29.43,0,53.37,23.95,53.37,53.37v284.62c0,29.42-23.94,53.37-53.37,53.37ZM533.7,589.26v26.68l.03-26.68h-.03ZM53.37,304.64v284.62h480.3l.03-284.62H53.37Z" />
      <path d="M464.75,298.07c-14.74,0-26.68-11.93-26.68-26.68v-73.49c0-79.69-64.84-144.53-144.53-144.53s-144.58,64.84-144.58,144.53v73.49c0,14.75-11.95,26.68-26.68,26.68s-26.68-11.93-26.68-26.68v-73.49C95.59,88.79,184.39,0,293.53,0s197.9,88.79,197.9,197.9v73.49c0,14.75-11.95,26.68-26.68,26.68Z" />
      <path d="M293.53,355.92c-30.75,0-55.61,24.86-55.61,55.56,0,21,11.73,39.04,28.88,48.52v62.59h53.37v-62.59c17.2-9.43,28.92-27.52,28.92-48.52,0-30.7-24.86-55.56-55.56-55.56h0Z" />
    </BaseIcon>
  );
};

export const LogoutIcon = ({
  fill = "black",
  height = "auto",
  mr = "8px",
  width = "16px",
}) => {
  return (
    <BaseIcon
      fill={fill}
      height={height}
      mr={mr}
      width={width}
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 587.07 600.36"
    >
      <g>
        <path d="M437.56,495.97c-5.26,0-10.57-1.61-15.15-4.93-11.5-8.38-14.04-24.49-5.66-36.01l112.69-154.79-112.69-154.92c-8.38-11.5-5.84-27.61,5.69-35.99,11.48-8.35,27.63-5.84,35.99,5.69l123.72,170.07c6.57,9.03,6.57,21.27,0,30.33l-123.72,169.97c-5.03,6.92-12.88,10.59-20.86,10.59Z" />
        <path d="M561.3,326H241.59c-14.25,0-25.77-11.53-25.77-25.77s11.52-25.77,25.77-25.77h319.71c14.25,0,25.77,11.53,25.77,25.77s-11.52,25.77-25.77,25.77Z" />
      </g>
      <path d="M25.77,600.36c-14.25,0-25.77-11.53-25.77-25.77V25.77C0,11.53,11.52,0,25.77,0s25.77,11.53,25.77,25.77v548.82c0,14.24-11.53,25.77-25.77,25.77Z" />
      <g>
        <path d="M370.69,600.36H25.77c-14.25,0-25.77-11.53-25.77-25.77s11.52-25.77,25.77-25.77h344.92c14.25,0,25.77,11.52,25.77,25.77s-11.52,25.77-25.77,25.77Z" />
        <path d="M370.69,51.54H25.77C11.52,51.54,0,40.01,0,25.77S11.52,0,25.77,0h344.92c14.25,0,25.77,11.53,25.77,25.77s-11.52,25.77-25.77,25.77Z" />
      </g>
    </BaseIcon>
  );
};

export const MissionControlIcon = ({
  fill = "black",
  height = "auto",
  mr = "8px",
  width = "16px",
}) => {
  return (
    <BaseIcon
      fill={fill}
      height={height}
      mr={mr}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 578.23 554.39"
    >
      <g id="Rectangle_1" data-name="Rectangle 1" style="isolation: isolate;">
        <g id="Rectangle_1-2" data-name="Rectangle 1">
          <rect
            x="85.95"
            y="7.5"
            width="398"
            height="284"
            rx="10"
            ry="10"
            style="fill: none; stroke: #000; stroke-miterlimit: 100; stroke-width: 15px;"
          />
        </g>
        <g id="Rectangle_1-3" data-name="Rectangle 1">
          <path
            d="M567.46,433.84l-82.01-93.05c0-1.98-4.48-3.58-10-3.58H97.45c-5.52,0-10,1.6-10,3.58L10.95,433c0,1.98-5.52,5.85,0,5.85h556.25c5.52,0,.25-3.03.25-5Z"
            style="fill: none; stroke: #000; stroke-miterlimit: 100; stroke-width: 15px;"
          />
        </g>
      </g>
      <g id="Rectangle_2" data-name="Rectangle 2" style="isolation: isolate;">
        <g id="Rectangle_2-2" data-name="Rectangle 2">
          <rect x="211.95" y="255.5" width="147" height="201" rx="50" ry="50" />
        </g>
      </g>
      <g
        id="Rectangle_2_copy"
        data-name="Rectangle 2 copy"
        style="isolation: isolate;"
      >
        <g id="Rectangle_2_copy-2" data-name="Rectangle 2 copy">
          <path d="M353.95,460.5h-137c-13.81,0-25,11.19-25,25s11.19,25,25,25h137c13.81,0,25-11.19,25-25s-11.19-25-25-25Z" />
        </g>
      </g>
      <g id="Rectangle_3" data-name="Rectangle 3" style="isolation: isolate;">
        <g id="Rectangle_3-2" data-name="Rectangle 3">
          <path d="M8.5,428.39c-4.69,0-8.5,3.81-8.5,8.5v109c0,4.69,3.81,8.5,8.5,8.5s8.5-3.81,8.5-8.5v-109c0-4.69-3.81-8.5-8.5-8.5Z" />
        </g>
      </g>
      <g id="Rectangle_3-3" data-name="Rectangle 3" style="isolation: isolate;">
        <g id="Rectangle_3-4" data-name="Rectangle 3">
          <path d="M569.73,428.39c-4.69,0-8.5,3.81-8.5,8.5v109c0,4.69,3.81,8.5,8.5,8.5s8.5-3.81,8.5-8.5v-109c0-4.69-3.81-8.5-8.5-8.5Z" />
        </g>
        <g>
          <polygon points="219.5 218.18 219.5 221.54 222.19 223.57 224.89 223.57 224.89 220.87 222.05 218.18 219.5 218.18" />
          <polygon points="187.16 197.97 171.21 191.23 160.22 195.95 160.22 202.01 152.14 202.01 149.44 220.58 154.83 223.57 156.18 233.67 133.27 236.75 133.27 239.73 156.26 239.2 180.44 228.75 203.6 245.12 208.72 245.12 208.72 239.73 187.16 224.24 187.16 197.97" />
          <polygon points="230.27 223.93 234.32 228.95 241.05 227.61 241.05 225.59 231.15 221.66 230.27 223.93" />
          <polygon points="246.44 228.95 248.37 243.4 251.83 245.12 262.61 237.68 249.69 228.95 246.44 228.95" />
          <path d="M445.83,93.75l-5.34-12.06,16.11-19.72-9.43-16.24h-8.76l-6.42,22.41s-17.85,4.26-17.85,4.26l-32.99,38h-10.78l4.96-11.44-6.14-18.98-8.5-1.91-6.48,8.76v16.18l-5.01,7.4-5.77-12.5,3.11-19.64,16.63-10.15-20.81-3.72-13.88,8.29-14.6-1.55,13.39-10.14-177.84-26.03v15.57l-10.78,27.59v10.85l-5.39,7.26,10.78,51.31,17.23,20.71,37.43,17.6h18.77l.5-5.39,10.91,1.46,19.97,25.49,12.64-5.39,15.08,28.65,12.97,3.69c-.34-.37,0-16.67,0-16.67l28.17-15.67,17.98,10.78,7.74-1.17-2.3-7.8,22.13-7.19,7.47,5.39,11.46-5.39,9.74,9.22v7.59l18.87,20.6,1.67-16.27-14.45-29.89,2.73-7.87,28.91-31.56-5.45-11.73,4.68-33.01,16.93-9.93ZM164.54,89.24c-6.94,0-12.57-5.63-12.57-12.57s5.63-12.57,12.57-12.57,12.57,5.63,12.57,12.57-5.63,12.57-12.57,12.57ZM191.95,162.07c-6.94,0-12.57-5.63-12.57-12.57s5.63-12.57,12.57-12.57,12.57,5.63,12.57,12.57-5.63,12.57-12.57,12.57ZM235.66,134.65c-6.94,0-12.57-5.63-12.57-12.57s5.63-12.57,12.57-12.57,12.57,5.63,12.57,12.57-5.63,12.57-12.57,12.57ZM254.53,82.48c-6.94,0-12.57-5.63-12.57-12.57s5.63-12.57,12.57-12.57,12.57,5.63,12.57,12.57-5.63,12.57-12.57,12.57ZM282.37,207.03c-6.94,0-12.57-5.63-12.57-12.57s5.63-12.57,12.57-12.57,12.57,5.63,12.57,12.57-5.63,12.57-12.57,12.57ZM306.29,101.43c0-6.94,5.63-12.57,12.57-12.57s12.57,5.63,12.57,12.57-5.63,12.57-12.57,12.57-12.57-5.63-12.57-12.57ZM326.32,165.67c-6.94,0-12.57-5.63-12.57-12.57s5.63-12.57,12.57-12.57,12.57,5.63,12.57,12.57-5.63,12.57-12.57,12.57ZM378.95,187.22c-6.94,0-12.57-5.63-12.57-12.57s5.63-12.57,12.57-12.57,12.57,5.63,12.57,12.57-5.63,12.57-12.57,12.57ZM409.53,117.84c-6.94,0-12.57-5.63-12.57-12.57s5.63-12.57,12.57-12.57,12.57,5.63,12.57,12.57-5.63,12.57-12.57,12.57Z" />
          <polygon points="208.82 216.25 212.44 218.18 214.11 216.83 214.11 212.79 210.89 212.79 208.82 216.25" />
        </g>
      </g>
      <g id="Rectangle_3-5" data-name="Rectangle 3" style="isolation: isolate;">
        <g id="Rectangle_3-6" data-name="Rectangle 3">
          <path d="M304.84,498.26c-2.63-3.89-7.91-4.92-11.8-2.29l-59.28,39.99c-3.89,2.63-4.92,7.91-2.29,11.8,2.63,3.89,7.91,4.92,11.8,2.29l59.28-39.99c3.89-2.63,4.92-7.91,2.29-11.8Z" />
        </g>
      </g>
      <g id="Rectangle_3-7" data-name="Rectangle 3" style="isolation: isolate;">
        <g id="Rectangle_3-8" data-name="Rectangle 3">
          <path d="M335.15,535.96l-59.28-39.99c-3.89-2.63-9.17-1.6-11.8,2.29s-1.6,9.17,2.29,11.8l59.28,39.99c3.89,2.63,9.17,1.6,11.8-2.29,2.63-3.89,1.6-9.17-2.29-11.8Z" />
        </g>
      </g>
      <g id="Rectangle_3-9" data-name="Rectangle 3" style="isolation: isolate;">
        <g id="Rectangle_3-10" data-name="Rectangle 3">
          <path d="M183.45,361.5h-83c-4.69,0-8.5,3.81-8.5,8.5s3.81,8.5,8.5,8.5h83c4.69,0,8.5-3.81,8.5-8.5s-3.81-8.5-8.5-8.5Z" />
        </g>
      </g>
      <g
        id="Rectangle_3-11"
        data-name="Rectangle 3"
        style="isolation: isolate;"
      >
        <g id="Rectangle_3-12" data-name="Rectangle 3">
          <path d="M470.45,361.5h-83c-4.69,0-8.5,3.81-8.5,8.5s3.81,8.5,8.5,8.5h83c4.69,0,8.5-3.81,8.5-8.5s-3.81-8.5-8.5-8.5Z" />
        </g>
      </g>
      <g
        id="Rectangle_3-13"
        data-name="Rectangle 3"
        style="isolation: isolate;"
      >
        <g id="Rectangle_3-14" data-name="Rectangle 3">
          <path d="M130.45,394.5h-39c-4.69,0-8.5,3.81-8.5,8.5s3.81,8.5,8.5,8.5h39c4.69,0,8.5-3.81,8.5-8.5s-3.81-8.5-8.5-8.5Z" />
        </g>
      </g>
      <g
        id="Rectangle_3-15"
        data-name="Rectangle 3"
        style="isolation: isolate;"
      >
        <g id="Rectangle_3-16" data-name="Rectangle 3">
          <path d="M193.45,394.5h-39c-4.69,0-8.5,3.81-8.5,8.5s3.81,8.5,8.5,8.5h39c4.69,0,8.5-3.81,8.5-8.5s-3.81-8.5-8.5-8.5Z" />
        </g>
      </g>
      <g
        id="Rectangle_3-17"
        data-name="Rectangle 3"
        style="isolation: isolate;"
      >
        <g id="Rectangle_3-18" data-name="Rectangle 3">
          <path d="M416.45,394.5h-39c-4.69,0-8.5,3.81-8.5,8.5s3.81,8.5,8.5,8.5h39c4.69,0,8.5-3.81,8.5-8.5s-3.81-8.5-8.5-8.5Z" />
        </g>
      </g>
      <g
        id="Rectangle_3-19"
        data-name="Rectangle 3"
        style="isolation: isolate;"
      >
        <g id="Rectangle_3-20" data-name="Rectangle 3">
          <path d="M479.45,394.5h-39c-4.69,0-8.5,3.81-8.5,8.5s3.81,8.5,8.5,8.5h39c4.69,0,8.5-3.81,8.5-8.5s-3.81-8.5-8.5-8.5Z" />
        </g>
      </g>
    </BaseIcon>
  );
};

export const PlusIcon = ({
  fill = "black",
  height = "auto",
  mr = "8px",
  width = "16px",
}) => {
  return (
    <BaseIcon
      fill={fill}
      height={height}
      mr={mr}
      width={width}
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 581.28 581.53"
    >
      <g>
        <path d="M290.64,412.67c-13.65,0-24.69-11.04-24.69-24.69v-194.44c0-13.65,11.04-24.69,24.69-24.69s24.69,11.04,24.69,24.69v194.44c0,13.65-11.04,24.69-24.69,24.69Z" />
        <path d="M387.86,315.46h-194.44c-13.65,0-24.69-11.04-24.69-24.69s11.04-24.69,24.69-24.69h194.44c13.65,0,24.69,11.04,24.69,24.69s-11.04,24.69-24.69,24.69Z" />
      </g>
      <path d="M290.59,581.53c-77.66,0-150.67-30.24-205.58-85.14-113.37-113.4-113.35-297.88.05-411.26C139.97,30.24,212.98,0,290.64,0s150.7,30.24,205.63,85.14c113.35,113.4,113.35,297.86,0,411.21-54.95,54.93-127.99,85.19-205.68,85.19ZM290.64,49.38c-64.48,0-125.09,25.1-170.66,70.67-94.13,94.13-94.16,247.29-.05,341.42,45.57,45.57,106.19,70.67,170.66,70.67s125.14-25.13,170.76-70.72c94.09-94.11,94.09-247.24,0-341.38-45.59-45.57-106.21-70.67-170.71-70.67Z" />
    </BaseIcon>
  );
};

export const ProfileIcon = ({
  fill = "black",
  height = "auto",
  mr = "8px",
  width = "16px",
}) => {
  return (
    <BaseIcon
      fill={fill}
      height={height}
      mr={mr}
      width={width}
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 488.2 653.68"
    >
      <path d="M246.47,303.9c-74.76,0-135.55-68.16-135.55-151.94S171.72,0,246.47,0s135.55,68.16,135.55,151.97-60.8,151.94-135.55,151.94ZM246.47,56.49c-43.58,0-79.06,42.84-79.06,95.47s35.47,95.44,79.06,95.44,79.06-42.81,79.06-95.44-35.47-95.47-79.06-95.47Z" />
      <path d="M450.77,653.68H37.49c-14.84,0-27.15-11.5-28.19-26.29L.2,494.04c-3.29-49.07,34.84-105.65,83.22-123.55,103.8-37.16,217.89-37.05,321.14-.08,48.77,17.96,86.89,74.56,83.42,123.72l-9.02,133.21c-1.02,14.84-13.32,26.34-28.19,26.34ZM63.86,597.18h360.51l7.25-106.92c1.55-22.01-18.78-56.6-46.34-66.76-90.51-32.38-191.6-32.5-282.55.06-27.22,10.1-47.61,44.77-46.15,66.7l7.28,106.92Z" />
    </BaseIcon>
  );
};

export const RefreshIcon = ({
  fill = "black",
  height = "auto",
  mr = "8px",
  width = "16px",
}) => {
  return (
    <BaseIcon
      fill={fill}
      height={height}
      mr={mr}
      width={width}
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 317.93 252"
    >
      <path d="M270.64,152.56c-2.8,0-5.59-.99-7.82-3l-35.56-31.92c-4.82-4.32-5.22-11.73-.89-16.54,4.33-4.82,11.74-5.21,16.54-.89l27.73,24.89,27.76-24.89c4.82-4.33,12.21-3.94,16.54.89,4.32,4.82,3.92,12.23-.89,16.54l-35.58,31.92c-2.23,2-5.02,3-7.83,3Z"/>
      <path d="M272.4,136.59c-6.47,0-11.72-5.24-11.72-11.72,0-55.93-45.51-101.44-101.45-101.44-34.91,0-66.94,17.61-85.69,47.09-3.47,5.45-10.7,7.05-16.18,3.59-5.46-3.47-7.07-10.71-3.59-16.18C76.85,21.66,116.27,0,159.23,0c68.86,0,124.88,56.01,124.88,124.87,0,6.48-5.24,11.72-11.72,11.72Z"/>
      <path d="M159.85,252c-68.86,0-124.89-56.02-124.89-124.9,0-6.48,5.24-11.72,11.72-11.72s11.72,5.24,11.72,11.72c0,55.94,45.51,101.47,101.46,101.47,34.89,0,66.94-17.62,85.71-47.12,3.48-5.43,10.72-7.05,16.18-3.59,5.46,3.48,7.07,10.72,3.59,16.18-23.11,36.3-62.53,57.97-105.48,57.97Z"/>
      <path d="M82.85,154.79c-2.79,0-5.59-.98-7.82-3l-27.73-24.91-27.76,24.91c-4.83,4.31-12.22,3.91-16.54-.89-4.32-4.82-3.92-12.22.89-16.54l35.58-31.93c4.46-4,11.21-4,15.65,0l35.56,31.93c4.82,4.32,5.22,11.73.89,16.54-2.31,2.57-5.51,3.89-8.72,3.89Z"/>
    </BaseIcon>
  );
};

export const ReturnIcon = ({
  fill = "black",
  height = "auto",
  mr = "8px",
  width = "16px",
}) => {
  return (
    <BaseIcon
      fill={fill}
      height={height}
      mr={mr}
      width={width}
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 331.1 269.25"
    >
      <g id="Layer_1-2" data-name="Layer 1">
        <g>
          <path d="M77.9,155.95c-3.6,0-7.1-1.4-9.9-4.1L4.1,87.75c-5.4-5.4-5.4-14.2,0-19.7L68,4.05c5.4-5.4,14.3-5.4,19.7,0,5.4,5.4,5.4,14.2,0,19.7l-54.2,54.2,54.2,54.2c5.4,5.4,5.4,14.3,0,19.7-2.7,2.7-6.3,4.1-9.8,4.1Z" />
          <path d="M228.3,269.25H13.9c-7.7,0-13.9-6.2-13.9-13.9s6.2-13.9,13.9-13.9h214.4c41.4,0,75-33.6,75-75s-33.6-75.1-75-75.1H23c-7.7,0-13.9-6.2-13.9-13.9s6.2-13.9,13.9-13.9h205.3c56.7,0,102.8,46.2,102.8,102.9s-46.1,102.8-102.8,102.8Z" />
        </g>
      </g>
    </BaseIcon>
  );
};

export const RightCaretIcon = ({
  fill = "black",
  height = "auto",
  mr = "8px",
  width = "16px",
}) => {
  return (
    <BaseIcon
      fill={fill}
      height={height}
      mr={mr}
      width={width}
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 425 564.6"
    >
      <g id="Layer_1-2" data-name="Layer 1-2">
        <g id="Layer_1-2-2" data-name="Layer 1-2">
          <g id="Triangle_1" data-name="Triangle 1">
            <g id="Triangle_1-2" data-name="Triangle 1-2">
              <polygon points="425 282.3 0 0 0 564.6 425 282.3" />
            </g>
          </g>
        </g>
      </g>
    </BaseIcon>
  );
};

export const SaveIcon = ({
  fill = "black",
  height = "auto",
  mr = "8px",
  width = "16px",
}) => {
  return (
    <BaseIcon
      fill={fill}
      height={height}
      mr={mr}
      width={width}
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 328 328"
    >
      <g id="Layer_1-2" data-name="Layer 1">
        <g>
          <path
            d="M318,83.7c0-10.2-4.1-20-11.3-27.2l-35.2-35.2c-7.2-7.2-17-11.3-27.2-11.3H48.5c-21.3,0-38.5,17.2-38.5,38.5v231c0,21.3,17.2,38.5,38.5,38.5h231c21.3,0,38.5-17.2,38.5-38.5V83.7Z"
            style="fill: none; stroke: #000; stroke-linecap: round; stroke-linejoin: round; stroke-width: 20px;"
          />
          <path
            d="M202.5,10v77h-115.5V10M87,318v-154h154v154"
            style="fill: none; stroke: #000; stroke-linecap: round; stroke-linejoin: round; stroke-width: 20px;"
          />
        </g>
      </g>
    </BaseIcon>
  );
};

export const SearchIcon = ({
  fill = "black",
  height = "auto",
  mr = "8px",
  width = "16px",
}) => {
  return (
    <BaseIcon
      fill={fill}
      height={height}
      mr={mr}
      width={width}
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 632.99 643.7"
    >
      <path d="M276.15,552.38C123.95,552.38.06,428.54,0,276.29.06,123.98,123.95.03,276.21,0c152.23,0,276.15,123.93,276.2,276.23,0,152.28-123.92,276.15-276.26,276.15ZM276.21,55.41c-121.71.03-220.74,99.11-220.79,220.87.06,121.68,99.06,220.68,220.74,220.68s220.84-99.03,220.84-220.74c-.05-121.76-99.08-220.82-220.79-220.82Z" />
      <path d="M605.28,643.7c-7.09,0-14.18-2.7-19.59-8.12l-154.28-154.26c-10.83-10.82-10.83-28.36,0-39.18,10.82-10.82,28.36-10.82,39.18,0l154.28,154.26c10.82,10.82,10.82,28.36,0,39.18-5.41,5.41-12.5,8.12-19.59,8.12Z" />
    </BaseIcon>
  );
};

export const SettingsIcon = ({
  fill = "black",
  height = "auto",
  mr = "8px",
  width = "16px",
}) => {
  return (
    <BaseIcon
      fill={fill}
      height={height}
      mr={mr}
      width={width}
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 614.64 614.64"
    >
      <path d="M340.93,614.64h-67.23c-24.54,0-44.49-19.95-44.49-44.49v-43.47l-20.87-8.07-31.64,29.83c-16.76,16.75-46.13,16.75-62.88,0l-47.56-47.58c-8.38-8.3-13.03-19.51-13.03-31.44s4.65-23.14,13.1-31.52l30.68-30.68-9.02-20.61-43.5-1.17c-24.55,0-44.49-19.95-44.49-44.47v-67.25c0-24.55,19.95-44.49,44.49-44.49h43.52l8.05-20.82-29.81-31.7c-8.38-8.3-13.03-19.51-13.03-31.44s4.65-23.14,13.1-31.52l47.48-47.51c16.7-16.75,46.15-16.78,62.91.03l30.73,30.73,20.48-9.02,1.28-43.47c0-24.54,19.95-44.49,44.49-44.49h67.23c24.57,0,44.54,19.95,44.54,44.49v43.5l20.84,8.1,31.62-29.86c8.43-8.4,19.59-13,31.47-13h0c11.88,0,23.04,4.6,31.44,12.98l47.56,47.61c8.35,8.3,13,19.51,13,31.44s-4.65,23.14-13.1,31.52l-30.68,30.67,9.04,20.54,43.52,1.22c24.49,0,44.44,19.95,44.44,44.49v67.25c0,24.52-19.95,44.47-44.44,44.47h-43.52l-8.12,20.89,29.83,31.65c8.38,8.3,13.03,19.51,13.03,31.44s-4.65,23.14-13.1,31.52l-47.41,47.48c-16.96,16.86-46.13,16.76-62.88.1l-30.83-30.83-20.51,9.02-1.2,43.45c0,24.55-19.97,44.49-44.54,44.49ZM281.52,562.33h51.65v-35.66c0-21.15,15.12-42.2,35.17-48.94l17.98-7.51c5.01-2.56,12.75-4.34,20.71-4.34,14.2,0,27.74,5.41,37.14,14.81l25.24,25.23,36.45-36.53-25.21-25.21c-14.97-15.02-19.11-40.59-9.66-59.54l7.36-17.98c6-18.36,27.05-33.56,48.32-33.56h35.66v-51.6h-35.66c-21.28,0-42.32-15.2-48.99-35.35l-7.46-17.85c-8.66-17.22-4.55-42.78,10.34-57.78l25.29-25.29-36.45-36.53-25.24,25.23c-14.74,14.71-40.87,18.95-59.56,9.68l-17.93-7.36c-18.36-6.08-33.51-27.1-33.51-48.3v-35.68h-51.65v35.68c0,21.23-15.2,42.27-35.32,48.96l-17.85,7.46c-5.01,2.58-12.77,4.34-20.74,4.34-14.23.03-27.79-5.39-37.16-14.81l-25.18-25.18-36.47,36.5,25.21,25.21c14.97,15.07,19.08,40.64,9.65,59.54l-7.28,17.91c-6.13,18.47-27.18,33.61-48.35,33.61h-35.71v51.6h35.71c21.18,0,42.22,15.15,48.96,35.22l7.46,18.06c8.66,17.22,4.52,42.78-10.42,57.78l-25.23,25.23,36.47,36.5,25.21-25.21c14.53-14.64,40.84-19,59.56-9.68l17.91,7.31c18.75,6.23,33.59,26.82,33.59,48.35v35.66ZM307.32,422.1c-63.27,0-114.73-51.49-114.73-114.78s51.47-114.79,114.73-114.79,114.79,51.49,114.79,114.79-51.49,114.78-114.79,114.78ZM307.32,244.84c-34.43,0-62.42,28.02-62.42,62.48s27.99,62.47,62.42,62.47,62.48-28.02,62.48-62.47-28.02-62.48-62.48-62.48Z" />
    </BaseIcon>
  );
};

export const SortIcon = ({
  fill = "black",
  height = "auto",
  mr = "8px",
  width = "16px",
}) => {
  return (
    <BaseIcon
      fill={fill}
      height={height}
      mr={mr}
      width={width}
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 637.72 615.89"
    >
      <g>
        <path d="M315.42,197.92c-6.87,0-13.74-2.62-18.99-7.87l-125.32-125.21-125.27,125.21c-10.49,10.49-27.49,10.49-37.98,0-10.49-10.49-10.49-27.49,0-37.98L152.12,7.87c10.49-10.49,27.49-10.49,37.98,0l144.31,144.2c10.49,10.47,10.49,27.49,0,37.98-5.25,5.25-12.12,7.87-18.99,7.87Z" />
        <path d="M171.17,615.89c-14.82,0-26.86-12.01-26.86-26.86l-.05-522.99c0-14.82,12.01-26.86,26.86-26.86s26.86,12.01,26.86,26.86l.05,522.99c0,14.82-12.01,26.86-26.86,26.86Z" />
      </g>
      <g>
        <path d="M466.6,615.89c-6.87,0-13.74-2.62-18.99-7.87l-144.31-144.2c-10.49-10.46-10.49-27.49,0-37.98,10.49-10.49,27.49-10.49,37.98,0l125.32,125.21,125.27-125.21c10.49-10.49,27.49-10.49,37.98,0,10.49,10.49,10.49,27.49,0,37.98l-144.26,144.2c-5.25,5.25-12.12,7.87-18.99,7.87Z" />
        <path d="M466.6,576.71c-14.82,0-26.86-12.01-26.86-26.86l-.05-522.99C439.69,12.04,451.7,0,466.55,0s26.86,12.01,26.86,26.86l.05,522.99c0,14.82-12.01,26.86-26.86,26.86Z" />
      </g>
    </BaseIcon>
  );
};

export const UnhideIcon = ({
  fill = "black",
  height = "auto",
  mr = "8px",
  width = "16px",
}) => {
  return (
    <BaseIcon
      fill={fill}
      height={height}
      mr={mr}
      width={width}
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 632.99 460.43"
    >
      <path d="M316.49,460.43c-145.23,0-271.88-89.1-315.12-221.68-1.83-5.56-1.83-11.52,0-17.07C44.64,89.1,171.29,0,316.49,0s271.85,89.1,315.13,221.68c1.83,5.56,1.83,11.51,0,17.07-43.25,132.58-169.9,221.68-315.13,221.68ZM56.56,230.22c38.44,105.2,141.74,175.24,259.93,175.24s221.49-70.04,259.94-175.24c-38.47-105.2-141.74-175.24-259.94-175.24S95.03,125.02,56.56,230.22Z" />
      <g>
        <path d="M316.49,379.12c-82.12,0-148.93-66.82-148.93-148.93,0-15.19,12.29-27.49,27.49-27.49s27.49,12.3,27.49,27.49c0,51.81,42.15,93.96,93.95,93.96,15.2,0,27.49,12.3,27.49,27.49s-12.29,27.49-27.49,27.49Z" />
        <path d="M437.89,257.68c-15.2,0-27.49-12.29-27.49-27.49,0-51.78-42.12-93.9-93.9-93.9-15.19,0-27.49-12.29-27.49-27.49s12.3-27.49,27.49-27.49c82.09,0,148.88,66.79,148.88,148.88,0,15.2-12.3,27.49-27.49,27.49Z" />
      </g>
      <g>
        <path d="M167.59,230.24c0-82.12,66.82-148.93,148.93-148.93,15.19,0,27.49,12.29,27.49,27.49s-12.3,27.49-27.49,27.49c-51.81,0-93.96,42.15-93.96,93.95,0,15.2-12.3,27.49-27.49,27.49s-27.49-12.29-27.49-27.49Z" />
        <path d="M289.03,351.63c0-15.2,12.29-27.49,27.49-27.49,51.78,0,93.9-42.12,93.9-93.9,0-15.19,12.29-27.49,27.49-27.49s27.49,12.3,27.49,27.49c0,82.09-66.79,148.88-148.88,148.88-15.2,0-27.49-12.3-27.49-27.49Z" />
      </g>
    </BaseIcon>
  );
};

export const UnlockIcon = ({
  fill = "black",
  height = "auto",
  mr = "8px",
  width = "16px",
}) => {
  return (
    <BaseIcon
      fill={fill}
      height={height}
      mr={mr}
      width={width}
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 587.07 642.63"
    >
      <path d="M533.7,642.63H53.37c-29.44,0-53.37-23.95-53.37-53.37v-284.62c0-29.42,23.93-53.37,53.37-53.37h480.33c29.43,0,53.37,23.95,53.37,53.37v284.62c0,29.42-23.94,53.37-53.37,53.37ZM53.37,304.64v284.62h480.37l-.04-284.62H53.37Z" />
      <path d="M416.95,122.76c-25.41-41.58-71.23-69.39-123.42-69.39-79.69,0-144.53,64.84-144.53,144.53v73.49h-53.37v-73.49C95.64,88.79,184.41,0,293.53,0c72.01,0,135.17,38.67,169.79,96.33" />
      <path d="M293.53,355.92c-30.7,0-55.61,24.86-55.61,55.56,0,21,11.78,39.04,28.93,48.52v62.59h53.37v-62.59c17.15-9.43,28.92-27.52,28.92-48.52,0-30.7-24.91-55.56-55.61-55.56h0Z" />
    </BaseIcon>
  );
};

export const UpCaretIcon = ({
  fill = "black",
  height = "auto",
  mr = "8px",
  width = "16px",
}) => {
  return (
    <BaseIcon
      fill={fill}
      height={height}
      mr={mr}
      width={width}
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 564.6 425"
    >
      <g id="Layer_1-2" data-name="Layer 1">
        <g id="Triangle_1" data-name="Triangle 1">
          <g id="Triangle_1-2" data-name="Triangle 1-2">
            <polygon points="282.3 0 0 425 564.6 425 282.3 0" />
          </g>
        </g>
      </g>
    </BaseIcon>
  );
};

export const ViewIcon = ({
  fill = "black",
  height = "auto",
  mr = "8px",
  width = "16px",
}) => {
  return (
    <BaseIcon
      fill={fill}
      height={height}
      mr={mr}
      width={width}
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 632.99 460.43"
    >
      <path d="M316.49,460.43c-145.23,0-271.88-89.1-315.13-221.68-1.83-5.56-1.83-11.52,0-17.07C44.64,89.1,171.29,0,316.49,0s271.85,89.1,315.13,221.68c1.83,5.56,1.83,11.51,0,17.07-43.25,132.58-169.9,221.68-315.13,221.68ZM56.56,230.22c38.44,105.2,141.74,175.24,259.93,175.24s221.49-70.04,259.93-175.24c-38.47-105.2-141.74-175.24-259.93-175.24S95.03,125.01,56.56,230.22Z" />
      <path d="M316.49,379.15c-82.12,0-148.93-66.82-148.93-148.93,0-15.19,12.3-27.49,27.49-27.49s27.49,12.3,27.49,27.49c0,51.81,42.15,93.96,93.96,93.96s93.9-42.15,93.9-93.96-42.12-93.9-93.9-93.9c-15.19,0-27.49-12.3-27.49-27.49s12.3-27.49,27.49-27.49c82.09,0,148.88,66.79,148.88,148.88s-66.79,148.93-148.88,148.93Z" />
      <path d="M465.4,230.22c0,82.12-66.82,148.93-148.93,148.93-15.19,0-27.49-12.3-27.49-27.49s12.3-27.49,27.49-27.49c51.81,0,93.96-42.15,93.96-93.96s-42.15-93.9-93.96-93.9-93.9,42.12-93.9,93.9c0,15.19-12.3,27.49-27.49,27.49s-27.49-12.3-27.49-27.49c0-82.09,66.79-148.88,148.88-148.88s148.93,66.79,148.93,148.88Z" />
    </BaseIcon>
  );
};
